import {SvgIcon} from '@mui/material';
import MainLinearGradient from './MainLinearGradient';

export default function ChannelsServiceIcon(props: { color?: string; }) {
	const {color = 'url(#paint0_linear_992_1034)'} = props;
	return (
		<SvgIcon width="32" height="32" viewBox="0 0 32 32" fill="none">
			<path
				d="M24.6268 22.4401L25.1468 26.6534C25.2802 27.7601 24.0935 28.5334 23.1468 27.9601L18.5335 25.2134C18.2135 25.0267 18.1335 24.6267 18.3068 24.3067C18.9735 23.0801 19.3335 21.6934 19.3335 20.3067C19.3335 15.4267 15.1468 11.4534 10.0002 11.4534C8.94684 11.4534 7.92017 11.6134 6.96017 11.9334C6.84667 11.9684 6.72592 11.9728 6.61019 11.9461C6.49445 11.9193 6.38785 11.8625 6.30119 11.7812C6.21454 11.7 6.15091 11.5973 6.11678 11.4835C6.08265 11.3697 6.07922 11.2489 6.10684 11.1334C7.32017 6.28008 11.9868 2.66675 17.5602 2.66675C24.0668 2.66675 29.3335 7.58675 29.3335 13.6534C29.3335 17.2534 27.4802 20.4401 24.6268 22.4401Z"
				fill={color}/>
			<path
				d="M17.3332 20.3067C17.3332 21.8934 16.7465 23.36 15.7598 24.52C14.4398 26.12 12.3465 27.1467 9.99984 27.1467L6.51984 29.2134C5.93317 29.5734 5.1865 29.08 5.2665 28.4L5.59984 25.7734C3.81317 24.5334 2.6665 22.5467 2.6665 20.3067C2.6665 17.96 3.91984 15.8934 5.83984 14.6667C7.0265 13.8934 8.45317 13.4534 9.99984 13.4534C14.0532 13.4534 17.3332 16.52 17.3332 20.3067Z"
				fill="url(#paint1_linear_992_1034)"/>
			<defs>
				<linearGradient id="paint0_linear_992_1034" x1="28.8374" y1="2.66675" x2="4.96273" y2="3.76882"
				                gradientUnits="userSpaceOnUse">
					<MainLinearGradient/>
				</linearGradient>
				<linearGradient id="paint1_linear_992_1034" x1="17.0202" y1="13.4534" x2="1.95708" y2="14.1575"
				                gradientUnits="userSpaceOnUse">
					<MainLinearGradient/>
				</linearGradient>
			</defs>
		</SvgIcon>
	);
}
